/* src/app/order-type/order-type.component.css */
.image {
  max-width: 30px;
  max-height: 30px;
}
/*# sourceMappingURL=order-type.component.css.map */
